import React, { useState, useEffect, useContext, useRef } from "react";
import "../../css_files/Master/CourierMaster.css";
import Table from "../Homepage/Table";
import AddCourierMaster from "./AddCourierMaster";
import SearchCourierMaster from "./SearchCourierMaster";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import getCookie from "../../api";
import { triggerscroll } from "../Homepage/Homepage";
import AddMaster from "./AddMaster";
import SearchMaster from "./SearchMaster";
import Pagination from "../Homepage/Pagination";
import axiosInstance from "../../api";

function CourierMaster() {
  const [showaddform, setshowaddform] = useState(false);
  const [showsearchform, setshowsearchform] = useState(false);
  const tablehead = ["Id", "Name", "Phone Number", "Address"];
  const [tabledata, setTableData] = useState([]);
  const [reload, setReload] = useState(false);
  const [triggerupdate, settriggerupdate] = useState(false);
  const [courierupdatedata, setcourierupdatedata] = useState(null);
  const [datareload, setdatareload] = useState(0);
  const [loading, setloading] = useState(false);
  const { setExpiredSession, permissionsdata, userData } =
    useContext(triggerscroll);
  const [pagenumber, setpagenumber] = useState(1);
  const [pagecount, setpagecount] = useState(0);
  const [excelloading, setexcelloading] = useState(false);
  const [totalcount, setTotalCount] = useState(0);
  const [courierId, setcourierId] = useState(null);
  const [search, setSearch] = useState("");
  const [Ids, setIds] = useState([]);

  function fetchcourierdata(courierid) {
    setcourierupdatedata(null);
    const url = `${process.env.REACT_APP_API_URL}/api/v1/Courier/GetCourierById?id=${courierid}`;
    axiosInstance
      .get(url)
      .then((res) => {
        setcourierupdatedata(res.data);
      })
      .catch(console.log);
  }

  useEffect(() => {
    setloading(true);
    const URL = `${process.env.REACT_APP_API_URL}/api/v1/Courier/${pagenumber}`;
    axiosInstance
      .post(URL, {
        Id: courierId || null,
        Search: search,
        Ids,
      })
      .then((response) => {
        setpagecount(response.data.count);
        setTotalCount(response.data.dataCount);
        setTableData(
          response.data.data.map((x) => [
            x.id,
            x.basicDetails,
            x.contacts,
            x.address,
          ])
        );
      })
      .catch(console.log)
      .finally(() => {
        setloading(false);
      });
  }, [reload, pagenumber, Ids.length]);

  function readPermission() {
    if (userData.role === "Administrator") return true;

    const issatisfied = permissionsdata.some(
      (x) => x.head === "Master" && x.subHead === "Courier" && x.isRead === true
    );
    return issatisfied;
  }

  function writePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" && x.subHead === "Courier" && x.isWrite === true
    );
    return !issatisfied;
  }

  function updatePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" && x.subHead === "Courier" && x.isUpdate === true
    );
    return !issatisfied;
  }

  function deletePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" && x.subHead === "Courier" && x.isDelete === true
    );
    return !issatisfied;
  }

  return (
    <section className="courier-master">
      <h1>Courier Master</h1>
      <blockquote className="courier-master-forms">
        <AddMaster
          text="Add Courier Master"
          setshowaddform={setshowaddform}
          settriggerupdate={settriggerupdate}
          setshowsearchform={setshowsearchform}
          permit={writePermission}
        />

        <SearchMaster
          text="Search Courier Master"
          setshowsearchform={setshowsearchform}
          setshowaddform={setshowaddform}
        />
      </blockquote>
      {showaddform && (
        <AddCourierMaster
          setshowaddform={setshowaddform}
          reload={reload}
          setReload={setReload}
          triggerupdate={triggerupdate}
          courierupdatedata={courierupdatedata}
          key={`${courierupdatedata?.id}-${triggerupdate}-${datareload}`}
        />
      )}
      {showsearchform && (
        <SearchCourierMaster
          setshowsearchform={setshowsearchform}
          setpagenumber={setpagenumber}
          setIds={setIds}
          setcourierId={setcourierId}
          setReload={setReload}
          setSearch={setSearch}
          reload={reload}
        />
      )}
      <Table
        tablehead={tablehead}
        tabledata={tabledata}
        setshowaddform={setshowaddform}
        settriggerupdate={settriggerupdate}
        fetchdata={fetchcourierdata}
        url="Courier/UpdateCourier"
        reload={reload}
        setReload={setReload}
        setdatareload={setdatareload}
        datareload={datareload}
        loading={loading}
        readPermission={readPermission}
        updatePermission={updatePermission}
        deletePermission={deletePermission}
        totalcount={totalcount}
      />
      <Pagination
        count={pagecount}
        setpagenumber={setpagenumber}
        pagenumber={pagenumber}
      />
    </section>
  );
}

export default CourierMaster;
